import { createFileRoute } from "@tanstack/react-router"

import { AssetTypeSettingsIdentifiersView } from "../../../../../../../../views/AssetTypeSettingsIdentifiersView/AssetTypeSettingsIdentifierView"
import { assetTypeIdentifiersViewStaticData } from "../../../../../../../../views/AssetTypeSettingsIdentifiersView/constants"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/identifiers",
)({
	component: AssetTypeSettingsIdentifiersView,
	staticData: assetTypeIdentifiersViewStaticData,
})
